export default "__VITE_ASSET__15870997__"